import React from 'react';
import styled from 'styled-components';
import {UtilityMenuBottomGradient} from './Gradients';

const AppNameStyle = styled.h1`
    margin-top: 10px;
    color: #6ca9e5;
    font-style: italic;
    font-size: 32px;
    font-weight: bolder;
`;

const AppName = () => (
  <div className="col-xs-12 pull-right col-sm-6">
    <div className="row">
      <UtilityMenuBottomGradient/>
    </div>
    <div className="row">
      <div className="col-xs-6 pull-right application-name">
        <AppNameStyle className="pull-right">Hawaii ePASRR</AppNameStyle>
      </div>
    </div>
  </div>
);

export default AppName;


// WEBPACK FOOTER //
// ./src/modules/layout/components/AppName.js